import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../store';

import type { AppDispatch } from '../../../../store';

export default function useFetchIntakeQuestionnaire() {
  const dispatch = useDispatch<AppDispatch>();
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!intakeQuestionnaireId) return;

    dispatch(
      intakeQuestionnaireActions.getIntakeQuestionnaireById({
        intakeQuestionnaireId,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, intakeQuestionnaireId]);
}
